
const CentralCard = ({ children }) => {

    return (
            // <div className="min-vh-50 d-flex flex-row align-items-center ">
                <div className="container-fluid">
                    <div className="row  justify-content-center">
                        <div className="col text-center">
                            {children}
                        </div>
                    </div>
                </div>
            // </div>
    );
}

export default CentralCard;